export const extractYoutubeVideoId = (url) => {
  if (!url) {
    return undefined;
  }

  const youtubeRegex =
    /* eslint-disable-next-line */
    /(?:https?:\/\/)?(?:www\.)?youtu\.?be(?:\.com)?\/?.*(?:watch|embed)?(?:.*v=|v\/|\/)([\w\-_]+)\&?/;

  const found = url.match(youtubeRegex);

  return found ? found[1] : undefined;
};
